module.exports = __webpack_public_path__ + "ffe9e7a4c866d11a8a3aada98520c568.svg";